import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
	selector: "stages-files-main",
	templateUrl: "./main.component.html",
	imports: [RouterOutlet],
})
export class MainComponent {}
